import { render, staticRenderFns } from "./ExportLocalRegionAnnotated.vue?vue&type=template&id=098bc399&scoped=true&"
import script from "./ExportLocalRegionAnnotated.vue?vue&type=script&lang=js&"
export * from "./ExportLocalRegionAnnotated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098bc399",
  null
  
)

export default component.exports